import { useLayoutIsXS } from '@segments/Responsive/client'

import { getSpacingValueInPx, TSingleSpace } from '~ui/styleGuide/spaces'
import { getPxInRem } from '~ui/styleGuide/styles'

import { menuScreenLayoutSettings } from '../config/menuScreenLayoutSettings'

const { topCardsGap, topCardsMarginBottom, mobileStickyCardHeightRem, tabletStickyCardHeightRem } =
  menuScreenLayoutSettings

/**
 * calculates and exports layout dimensions based on the viewport size
 */
export const useMenuScreenLayout = () => {
  const isMobileScreen = useLayoutIsXS()

  const stickyTopCardPaddingTop: TSingleSpace = isMobileScreen ? `smallMedium` : topCardsGap
  const mobileStickyCardHeightPx = mobileStickyCardHeightRem * getPxInRem()
  const tabletStickyCardHeightPx = tabletStickyCardHeightRem * getPxInRem()

  const stickyTopCardHeight = isMobileScreen //
    ? mobileStickyCardHeightPx
    : tabletStickyCardHeightPx

  const navigationAndCartStickyTopPx =
    stickyTopCardHeight + getSpacingValueInPx(topCardsMarginBottom)

  return {
    isMobileScreen,
    topCardsMarginBottom,
    stickyTopCardHeight,
    stickyTopCardPaddingTop,
    navigationAndCartStickyTopPx,
  }
}
